import { LoginResponseDto } from '../../lib/api';
import { Outlet, useParams, useRouteLoaderData } from 'react-router-dom';
import Content from '../../components/content';
import { Building2 } from 'lucide-react';

export function CompanyLayout() {
    const params = useParams<'companyId'>();
    const session = useRouteLoaderData('root') as LoginResponseDto;
    const headerTitle = params.companyId ? session.activeOrg?.name : 'Add Company';

    return (
        <Content headerTitle={headerTitle} headerIcon={<Building2 size="15" />} backNavLink="/organization/overview">
            {{ content: <Outlet /> }}
        </Content>
    );
}
